export const normalizePhoneNumber = (phone: string | null | undefined) => {
    if (!phone) {
        return null;
    }
    if (phone.startsWith("+351") && phone.length === 13) {
        const normalized = phone.slice(4);
        return normalized;
    }
    if (phone.startsWith("351") && phone.length === 12) {
        const normalized = phone.slice(3);
        return normalized;
    }
    return phone;
};
